import Experience from "../../Experience";

export default class PartnersBannerBuilder {
    constructor() {
        this.experience = new Experience();
        this.data = [
            this.experience.router.main_data.data.main_partner_logo1,
            this.experience.router.main_data.data.main_partner_logo2,
            this.experience.router.main_data.data.main_partner_logo3,
            this.experience.router.main_data.data.main_partner_logo4,
            this.experience.router.main_data.data.main_partner_logo5,
            this.experience.router.main_data.data.main_partner_logo6,
            this.experience.router.main_data.data.main_partner_logo7,
            this.experience.router.main_data.data.main_partner_logo8,
            this.experience.router.main_data.data.main_partner_logo9,
        ].filter(Boolean)

        this.container = document.querySelector('.home-banner-container')
        this.cards = []
        this.speed = 0.18   // px per ms
        this.lastTime = null
        this._bound_tick = this._tick.bind(this)

        this.data.forEach((item) => {
            const card = document.createElement('div')
            card.className = 'partnerCard'
            card.style.cssText = `
                position: absolute;
                top: 0; left: 0;
                animation: none;
                display: flex;
                justify-content: center;
                align-items: center;
            `
            const img = document.createElement('img')
            img.src = item.url
            img.alt = ''
            card.appendChild(img)
            this.container.appendChild(card)
            this.cards.push(card)
        })

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') this.lastTime = null
        })

        requestAnimationFrame(() => this._init())
    }

    _init() {
        if (!this.cards.length) return

        const cardW = this.cards[0].offsetWidth
        const gap   = 80
        this.slot   = cardW + gap
        this.cardW  = cardW

        // positions[] holds the actual pixel x of each card's left edge.
        // Pre-fill: place cards so they cover the screen from x=0 rightward.
        // Some will be off-screen right — that's fine, they scroll in naturally.
        this.positions = this.cards.map((_, i) => i * this.slot)

        this._render()
        requestAnimationFrame(this._bound_tick)
    }

    _render() {
        this.positions.forEach((x, i) => {
            this.cards[i].style.transform = `translateX(${x}px)`
        })
    }

    _tick(now) {
        if (this.lastTime === null) {
            this.lastTime = now
            requestAnimationFrame(this._bound_tick)
            return
        }

        const dt = Math.min(now - this.lastTime, 100)
        this.lastTime = now

        const move = this.speed * dt

        // Move every card left
        this.positions = this.positions.map(x => x - move)

        // Find the rightmost x BEFORE we wrap anyone, so wrapping cards
        // always land exactly one slot past the current rightmost card.
        const maxX = Math.max(...this.positions)

        // Wrap any card that has fully exited the left edge
        this.positions = this.positions.map(x => {
            if (x + this.cardW < 0) {
                // Place it exactly one slot to the right of the current rightmost card
                return maxX + this.slot
            }
            return x
        })

        this._render()
        requestAnimationFrame(this._bound_tick)
    }
}
